import React from "react";
import { useRecordContext } from "react-admin";


export const OrderStatus = ({ source }) => {
  const record = useRecordContext();
  return (
    <span
      style={{
        backgroundColor: record.points > 0 ? "#0E8A16":'#b60205',
        padding: "5px 10px",
        borderRadius: "15px",
        color: record.points > 0 ? "#ffffff" : "#ffffff",
      }}
    >
        {record.points}
    </span>
  );
};